/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ServiceEventUpdateDto
 */
export interface ServiceEventUpdateDto {
    /**
     *
     * @type {Date}
     * @memberof ServiceEventUpdateDto
     */
    scheduledDate?: Date;
    /**
     * Array of ticket IDs
     * @type {Array<string>}
     * @memberof ServiceEventUpdateDto
     */
    ticketIds?: Array<string>;
}

/**
 * Check if a given object implements the ServiceEventUpdateDto interface.
 */
export function instanceOfServiceEventUpdateDto(
    value: object,
): value is ServiceEventUpdateDto {
    return true;
}

export function ServiceEventUpdateDtoFromJSON(
    json: any,
): ServiceEventUpdateDto {
    return ServiceEventUpdateDtoFromJSONTyped(json, false);
}

export function ServiceEventUpdateDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ServiceEventUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        scheduledDate:
            json["scheduledDate"] == null
                ? undefined
                : new Date(json["scheduledDate"]),
        ticketIds: json["ticketIds"] == null ? undefined : json["ticketIds"],
    };
}

export function ServiceEventUpdateDtoToJSON(
    value?: ServiceEventUpdateDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        scheduledDate:
            value["scheduledDate"] == null
                ? undefined
                : value["scheduledDate"].toISOString(),
        ticketIds: value["ticketIds"],
    };
}
